import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { store } from './redux/store';
import { ToastProvider } from './components/common/Toast/ToastContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    {/* TODO : Add a loader for i18n translation */}
    <Provider store={store}>
      <Suspense fallback="loading...">
        <ToastProvider>
          <App />
        </ToastProvider>
      </Suspense>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
